import tmhRequest from '@/config/tmhRequest'


export default {
    searchListCustomerSource: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/customersource/searchlistcustomersource',
            method: 'post',
            params: data,
        })
    },

    searchListCustomerSourceTree: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/customersource/searchlistcustomersourcetree',
            method: 'post',
            params: data,
        })
    },

    addCustomerSource: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/customersource/addcustomersource',
            method: 'post',
            params: data,
        })
    },

    editCustomerSource: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/customersource/editcustomersource',
            method: 'post',
            params: data,
        })
    },

    deleteCustomerSource: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/customersource/deletecustomersource',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/baseinfo/customersource.js